<template>
  <div class="divBox " id="data-list-content" style="overflow-y: scroll;height: 90vh">
    <el-card class="box-card" style="min-height: 500px">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="16">
            <el-form-item label="快递单号：" prop="express_num">
              <el-input v-model="formValidate.express_num" ref="expNum" @input="getOrderByExpFn"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div style="position: fixed;display: flex;flex-direction: column;right: 0px">
              <video id="video" :width="640" :height="500">
              </video>
              <canvas style="margin-top: 10px;opacity: 0;position: absolute;top: 0" id="canvasCamera" width="800"
                      height="800"></canvas>
            </div>

          </el-col>
          <template v-if="orderInfo.category_id">
            <el-col :span="24">
              <el-form-item :label="'物流信息'+(index+1)+'：'" prop="express_num"
                            v-for="(item,index) in orderInfo.express_list">
                {{ item.express_company }} - 【{{ item.express_num }}】 - <span class="status"
                                                                              :style="item.express_status == 1 ? 'color:#B5B5B8' : 'color:#ED4655'">
                {{ statusFn(item) }}</span>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="16" v-if="is_search">
            <el-form-item label="商品入库信息：">
              <div style="display: flex;flex-wrap: wrap;margin: 50px 0px 10px">
                <div style="white-space: nowrap;margin-bottom: 10px">商品入库照片：
                  <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline"
                             @click="addPutInPicFn">添加图片
                  </el-button>
                </div>
                <div style="width: 100%;">
                  <el-upload
                    action="#"
                    list-type="picture-card"
                    :file-list="fileListFn(formValidate.image)"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :auto-upload="false">
                    <div style="width: 150px;height: 150px;border: 2px solid #eeeeee;display: flex;align-items: center;justify-content: center">
                      <i slot="default" class="el-icon-plus"></i>
                    </div>
                  </el-upload>
                </div>
              </div>
              <div style="display: flex;flex-wrap: wrap;margin: 50px 0px 10px">
                <div style="white-space: nowrap;margin-bottom: 10px">商品入库视频：
                </div>
                <div style="width: 100%;display: flex">
                  <div style="margin-right: 10px;position: relative" v-for="(v,i) in formValidate.express_video"
                       v-if="i<3">
                    <el-popconfirm
                      title="确定删除吗？"
                      @confirm="delVideoFn(i)"
                    >
                      <div slot="reference"
                           style="font-size: 20px;position: absolute;right: 0;top: 20px;z-index: 10;cursor: pointer;width: 30px;height: 30px;color: red;text-align: center;line-height: 30px">
                        <i class="el-icon-error"></i></div>
                    </el-popconfirm>
                    <video wmode="Opaque" width="150px" height="150px" controls :src="v"></video>
                  </div>
                  <el-upload
                    class="avatar-uploader"
                    action="#"
                    :header="header"
                    :show-file-list="false"
                    auto-upload
                    :http-request="httpRequest"
                    :on-success="handleAvatarSuccess"
                    :on-change="videoChange">
                    <div style="width: 150px;height: 150px;display: flex;align-items: center;justify-content: center;border: 2px solid #eeeeee;font-size: 30px">
                      <i class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                  </el-upload>
                </div>
              </div>
              <div style="display: flex;margin: 10px 0px 0px">
                <div style="white-space: nowrap">入库备注：</div>
                <div style="width: 30%">
                  <el-input v-model="formValidate.express_remark"></el-input>
                </div>
              </div>
              <div style="display: flex;margin: 30px 0px 30px;padding-bottom: 20px;border-bottom:1px dashed black;">
                <div style="white-space: nowrap">商品条码：</div>
                <div style="width: 30%">
                  <el-input ref="warehousCode" v-model="warehousCode" @input="getSkuBy69Fn"></el-input>
                </div>
              </div>
              <div style="display: flex;border-bottom:1px dashed black;min-height: 500px">
                <div style="width: 55%;border-right: 1px dashed #000;margin-right: 20px">
                  <div>报单信息：</div>
                  <el-col :span="24">
                    <div class="list" v-for="(item,index) in orderInfo.product_list">
                      <div style="font-weight: bold;font-size: 18px" v-if="item.category_name">{{ item.category_name }}：</div>
                      <div class="item" v-for="(item1,index1) in item.sku_list">
                        <span>{{ skuFn(item1) }}</span>
                        <span style="margin-left: 10px;font-size: 14px;font-weight: bold">数量x{{ item1.num }}</span>
                        <el-button type="primary" size="mini" style="margin-left: 20px" icon="el-icon-circle-plus-outline"
                                   @click="addPutInFn(item1,item)">添加入库
                        </el-button>
                      </div>
                    </div>
                  </el-col>
                </div>
                <div style="display: flex;flex-direction: column;width:88%;overflow-y: scroll;height: 500px">
                  <div style="margin-bottom: 20px;width: 45%" v-for="(item,index) in formValidate.sku_list">
                    <div
                      style="display: flex;flex-direction: column;justify-content: space-between;width: 500px;flex-wrap: wrap;padding-bottom: 20px;">
                      <div style="white-space: nowrap">{{ item.cate_name }} {{ skuFn(item) }}</div>
                      <div style="display: flex;align-items: center;margin: 20px 0;">
                        <el-switch
                          style="display: flex;align-items: center;flex-wrap: nowrap;white-space: nowrap;line-height:22px;margin-left: 20px"
                          v-model="item.is_abnormal"
                          active-color="#ff4949"
                          :width="60"
                          :active-value="1"
                          :inactive-value="0"
                          active-text="异常"
                          inactive-text="无异常"
                          @change="statusChangeFn($event,item)">
                        </el-switch>
                        <el-switch
                          style="display: flex;align-items: center;flex-wrap: nowrap;white-space: nowrap;line-height:22px;margin-left: 20px"
                          v-model="item.is_fail"
                          active-color="#ff4949"
                          :width="60"
                          :active-value="1"
                          :inactive-value="0"
                          active-text="假货"
                          inactive-text="无假货"
                          @change="failChangeFn($event,item)">
                        </el-switch>
                      </div>
                      <div style="display: flex;width: 350px;align-items: center">
                        <span>入库数量：</span>
                        <el-input-number :min="0" v-model="item.num" :step="1" @change="batchChangeFn(item,index)"
                                         size="medium"></el-input-number>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" style="margin-left: 10px"
                                   :disabled="addBatFn(item)"
                                   @click="addBatchFn(item,index)" size="mini">批号
                        </el-button>

                      </div>
                      <div style="display: flex;flex-direction: column; margin-top: 10px">
                        <!--                    <div style="width: 230px">-->
                        <!--                      <el-input v-model="item.remark" placeholder="请输入异常备注"></el-input>-->
                        <!--                    </div>-->
                        <div style="display: flex;align-items: center" v-if="item.is_fail">
                          <span style="white-space: nowrap">假货数量：</span>
                          <el-input-number :min="1" v-model="item.fail_num" :step="1" size="medium"></el-input-number>
                        </div>
                        <div style="display: flex;align-items: center;margin-top: 10px" v-if="item.is_abnormal">
                          <span style="white-space: nowrap">异常数量：</span>
                          <el-input-number :min="0" :max="item.num" v-model="item.abnormal_num"
                                           @change="expitionNumChangeFn($event,item)" :step="1"
                                           size="medium"></el-input-number>
                        </div>

                      </div>
                      <div style="width: 100%;display: flex;margin-top: 10px;" v-for="(itemk,indexk) in item.batch_list">
                        <div style="width: 440px;display: flex;align-items: center">
                          <span style="white-space: nowrap">录入批号：</span>
                          <el-input ref="batchNum" v-model="itemk.batch_number" placeholder="请输入商品批号"></el-input>
                        </div>
                        <div style="margin-left: 10px;">
                          <el-input-number :min="0" @change="batchFn($event,index,indexk,item)" :max="maxFn(item,itemk)"
                                           v-model="itemk.batch_num" :step="1" size="medium"></el-input-number>
                        </div>
                      </div>
                      <div style="width: 100%; margin-top: 10px;">
                        <div style="display: flex;align-items: center" v-if="item.is_abnormal">
                          <span>异常备注：</span>
                          <div>
                            <el-select v-model="item.remarkSelect" placeholder="请选择">
                              <el-option
                                v-for="v in reamrkList"
                                :key="v"
                                :label="v"
                                :value="v">
                              </el-option>
                            </el-select>
                          </div>
                          <div style="width: 230px">
                            <el-input v-model="item.remark" v-if="item.remarkSelect=='其他'" placeholder="请输入异常备注"></el-input>
                          </div>
                        </div>
                        <div style="width: 100%;display: flex;margin-top: 10px;flex-wrap: wrap"
                             v-if="item.is_abnormal || item.is_fail">
                          <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline"
                                     @click="addExpPicFn($event,item)">异常图片
                          </el-button>

                          <div style="width: 100%;margin-top: 10px">
                            <el-upload
                              action="#"
                              list-type="picture-card"
                              :file-list="fileListFn(item.image)"
                              :auto-upload="false"
                              multiple>
                              <div slot="file" slot-scope="{file}">
                                <img
                                  class="el-upload-list__item-thumbnail"
                                  :src="file.url" alt=""
                                >
                                <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-preview"
                              @click="handlePictureCardPreview(file)"
                            >
                              <i class="el-icon-zoom-in"></i>
                            </span>
                            <span
                              class="el-upload-list__item-delete"
                              @click="handleExpRemove(file.url,item)"
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                              </div>
                              <i slot="default" class="el-icon-plus"></i>
                            </el-upload>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </el-form-item>
          </el-col>

        </el-row>
        <div style="transform: translateX(500px);display: flex">
          <el-form-item style="margin-top:10px;" v-if="is_search"><!--v-if="orderInfo.category_id"-->
            <el-button type="primary" class="submission" size="small" @click="addGoodFn">添加商品
            </el-button>
            <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提 交
            </el-button>
          </el-form-item>
        </div>

      </el-form>
    </el-card>
    <el-dialog title="添加商品" :visible.sync="visibleAddGood" width="500px" @close="closeDialogFn">
      <div style="margin: 0px 0px 10px">
        <el-input
          placeholder="输入自定义商品名"
          v-model="customName">
          <el-button slot="append" type="primary" icon="el-icon-circle-plus-outline" @click="addCustomGoodNameFn"
                     size="mini">添加
          </el-button>
        </el-input>
        <div style="margin: 10px 0">
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText">
          </el-input>
        </div>
      </div>
      <div style="max-height: 500px;overflow: scroll;">
        <el-tree ref="elTree" node-key="recovery_category_id" :filter-node-method="filterNodeFn" :data="treeData"
                 show-checkbox :props="defaultProps" @check-change="handleCheckChange"></el-tree>
      </div>
      <div style="width: 100%;text-align: center;margin-top: 20px">
        <el-button type="primary" @click="choiceGoodsFn">确定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="添加商品" :visible.sync="addSkuShow" width="500px" @close="closeFn">
      <div></div>
      <div style="width: 100%;text-align: center;margin-top: 20px">
        <div class="addSkuList">
          <div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 20px"
               v-for="(item,index) in addSkuList">

            <el-radio v-model="addSkuIndex" :label="index" size="medium">
              <div>{{ item.cate_name }}/{{ item.sku }}</div>
            </el-radio>
          </div>
        </div>
        <el-button type="info" @click="addSkuShow = false">取消</el-button>
        <el-button type="primary" @click="addSkuConfirmFn">确定</el-button>
      </div>
    </el-dialog>


    <el-dialog
      title="温馨提示"
      :visible.sync="VisibleShow"
      width="30%"
      :before-close="handleClose">
      <span>{{ formValidate.express_num }} 该物流单号暂未报单，请仔细核对后确认是否继续入库</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="confirmFn">继 续 入 库</el-button>
      </span>
    </el-dialog>


    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {roterPre} from '@/settings'
import {
  base64ToBlob,
  getFilenameAndMimetypeFromBase64
} from "@/utils/base64toFile.js"
import {
  orderWarehousApi,
  uploadFileApi,
  recoveryCategorySkuListApi,
  recoverySearchSkuBy69NumApi,
  recoveryOrderDetailByExpNumApi, stockGetTempKeysApi
} from "@/api/recovery";
import {getNowDateFn} from "@/utils/timeOptions";

import {getToken} from "@/utils/auth";
import orderWornHandle from "@/views/recovery/order/orderWornHandle.vue";
import SettingMer from "@/libs/settingMer";
import item from "@/layout/components/Sidebar/Item.vue";
import Cos from "cos-js-sdk-v5";


const defaultObj = {
  express_num: '',
}
export default {
  name: 'warehousing',
  components: {orderWornHandle},
  data() {
    return {
      header:{
        'X-Token':  getToken(),

      },
      waterLogo: null,
      dialogImageUrl: '',//图展示
      dialogVisible: false,
      imgif: false,
      contextCamera: null,
      canvasCamera: null,
      waterCof:null,
      videoCamera: null,
      addSkuData: {},
      addSkuShow: false,
      addSkuList: [],
      file:null,
      customName: '',//自定义商品名
      addSkuIndex: 0,
      tags: [],
      filterText: '',
      treeData: [],
      remarkSelect:'',
      VisibleShow: false,
      defaultProps: {
        children: 'children',
        label: 'cate_name'
      },
      reamrkList:['压盒代卖','严重压盒代卖或自行退回','盒裂代卖或自行退回','其他'],
      visibleAddGood: false,
      is_search: false,
      warehousCode: '',
      orderInfo: {category_id: null},
      isSearchExp: null,
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: {
        express_num: '',
        sku_list: [],
        express_remark:'',
        image: []
      },
      loading: false,
    }
  },
  computed: {
    item() {
      return item
    },
    fileListFn() {//异常图片回显数据处理
      return function (image) {
        let list = []
        image.forEach((res) => {
          list.push({url: res})
        })
        return list
      }
    },
    addBatFn() {
      return function (item) {
        let val = false
        let total = 0
        if (item.batch_list) {
          item.batch_list.forEach((r) => {
            total += r.batch_num
          })
        }
        if (total >= item.num) {
          val = true
        }
        return val
      }
    },
    maxFn() {
      return function (item, itemk) {
        let val = item.num
        let val2 = 0
        if (item.batch_list) {
          item.batch_list.forEach((r) => {
            val2 += r.batch_num
          })
        }
        val = val - val2 + itemk.batch_num
        return val
      }
    },
    minFn() {
      return function (item) {
        let val = 0
        if (item.batch_list) {
          item.batch_list.forEach((r) => {
            val += r.batch_num
          })
        }
        return val
      }
    },
    skuFn() {
      return function (item) {
        if (item.sku) {
          let arr = item.sku.split(',')
          if (arr.length > 1) {
            return arr[0] + '+' + arr[1]
          } else {
            return item.sku
          }
        } else {
          return item.sku
        }

      }
    },
    statusFn() {
      return function (item) {
        return item.express_status == 1 ? '已入库' : '待入库'
      }
    },
  },
  mounted() {
    let that = this
    this.$nextTick(() => {
      that.$refs.expNum.focus()
      let image = new Image()
      image.src = "http://cdn.wyzhenmei.com/def/waterlogo.png"
      image.crossOrigin = "Anonymous"
      image.onload = function () {
        that.waterLogo = image
      }
    })
    this.getGoodsFn()
    this.getPicOrVideoFn()
    this.getwaterCofFn() // 获取上传视频配置

  },
  watch: {
    filterText(val) {//过滤树形图
      this.$refs.elTree.filter(val);
    }
  },
  methods: {

    handleClose() {
      this.orderInfo = {}
      let num = this.formValidate.express_num
      this.formValidate = {
        express_num: '',
        image: [],
        express_remark: '',
        is_abnormal: 0,
        express_video: [],
        sku_list: [],
      }
      this.is_search = false
      this.warehousCode = ''
      this.VisibleShow = false
    },
    closeFn() {
      this.addSkuShow = false
    },
    confirmFn() {
      this.orderInfo = {category_id: 0}
      let num = this.formValidate.express_num
      this.formValidate = {
        express_num: num,
        image: [],
        express_remark: '',
        is_abnormal: 0,
        express_video: [],
        sku_list: [],
      }
      this.VisibleShow = false
      this.warehousCode = ''
    },
    delVideoFn(i) {//删除视频
      this.$nextTick(() => {
        this.formValidate.express_video.splice(i, 1)
        this.$forceUpdate()
      })
    },
    handleExpRemove(url, item) {//删除异常图片
      let index = 'index'
      item.image.some((r, i) => {
        if (r == url) {
          index = i
          return true
        }
      })
      if (index != 'index') {
        item.image.splice(index, 1)
      }
    },
    addPutInPicFn() {//添加入库图片
      this.setImage()
      this.$nextTick(() => {
        const blob = base64ToBlob(this.imgSrc);
        console.log(blob)
        const [filename, mimeType] = getFilenameAndMimetypeFromBase64(this.imgSrc);
        const file = new File([blob], filename, {type: mimeType});
        const formData = new FormData();
        formData.append('file', file, 'a.png');
        uploadFileApi(formData, {headers: {"content-type": "multipart/form-data"}}).then((res) => {
          this.formValidate.image.push(res.data.src)
        }).catch((res) => {
          this.$message.error(res.message)
        })
      })
    },
    addExpPicFn(e, item) {//添加异常图片
      this.setImage()
      this.$nextTick(() => {
        const blob = base64ToBlob(this.imgSrc);
        const [filename, mimeType] = getFilenameAndMimetypeFromBase64(this.imgSrc);
        const file = new File([blob], filename, {type: mimeType});
        const formData = new FormData();
        formData.append('file', file, 'a.png');
        uploadFileApi(formData, {headers: {"content-type": "multipart/form-data"}}).then((res) => {
          item.image.push(res.data.src)
        }).catch((res) => {
          this.$message.error(res.message)
        })

      })
    },
    handleRemove(file, fileList) {//删除入库图片
      this.$nextTick(() => {
        let img = fileList.map((r) => {
          return r.url
        })
        this.formValidate.image = img
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    setImage() {//拍照
      let that = this
      this.imgif = true
      this.contextCamera.drawImage(this.videoCamera, 0, 0, 800, 800)
      // this.contextCamera.drawImage(this.waterLogo, 10, 10, 55, 40)
      // this.contextCamera.font = '24px 宋体'
      // this.contextCamera.fillStyle = '#000000'
      // this.contextCamera.textAlign = 'left'
      // this.contextCamera.fillText(getNowDateFn(), 10, this.canvasCamera.height - 50)
      // this.contextCamera.fillText('快递单号：' + this.formValidate.express_num, 10, this.canvasCamera.height - 15)
      // 获取图片base64链接
      that.imgSrc = that.canvasCamera.toDataURL('image/png')
      // that.imgSrc = images
    },
    getPicOrVideoFn() {//获取摄像头
      let _this = this
      this.videoCamera = document.getElementById('video')
      this.canvasCamera = document.getElementById('canvasCamera')
      this.contextCamera = this.canvasCamera.getContext("2d");
      console.log(this.canvasCamera,this.contextCamera,'----------------')
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          let getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      var constraints = {
        audio: false,
        video: {width: 400, height: 340, transform: 'scaleX(-1)'}
      }
      navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
        // 旧的浏览器可能没有srcObject
        if ('srcObject' in _this.videoCamera) {
          _this.videoCamera.srcObject = stream
        } else {
          // 避免在新的浏览器中使用它，因为它正在被弃用。
          _this.videoCamera.src = window.URL.createObjectURL(stream)
        }
        // 获取video track
        const videoTrack = stream.getVideoTracks()[0];
        // 获取分辨率信息

        // 设置分辨率和帧率
        const constraints = {
          width: { ideal: 4000 },
          height: { ideal:  4000},
          frameRate: { ideal: 30, max: 60 }
        };
        videoTrack.applyConstraints(constraints);
        const { width, height } = videoTrack.getSettings();
        console.log(width,height,'00000000000000')
        _this.videoCamera.onloadedmetadata = function (e) {
          _this.videoCamera.play()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    //异常数量扣除
    expitionNumChangeFn(e, item) {
      if (e == 0) {
        this.$nextTick(() => {
          item.is_abnormal = 0
        })
      }
    },
    failChangeFn(e, item) {
      if (e) {
        item.fail_num = 1
      } else {
        item.fail_num = 0
      }
    },
    //异常改变
    statusChangeFn(e, item) {
      if (e) {
        item.abnormal_num = 1
      } else {
        item.abnormal_num = 0
      }
    },
    addCustomGoodNameFn() {
      this.customName = this.customName.trim()
      if (!this.customName) {
        this.$message({
          message: '请输入自定义商品的名字',
          type: 'error',
          duration: 3000,
          showClose: true,
          offset: 300
        })
        return
      }
      this.formValidate.sku_list.push({
        sku: this.customName,
        recovery_attr_id: '',
        image: [],
        remark: '',
        is_abnormal: 0,
        is_fail: 0,
        fail_num: 0,
        num: 1,
        recovery_category_id: '',
        abnormal_num: '', //异常数量
        is_Show: false,
        batch_list: [],
      })
      this.visibleAddGood = false
      this.closeDialogFn()
      this.customName = ''
    },
    batchChangeFn(item, index) {//删除sku
      if (item.num < item.abnormal_num) {
        item.abnormal_num = item.num
      }
      if (item.num == 0) {
        this.$nextTick(() => {
          this.formValidate.sku_list.splice(index, 1)
        })
      }
    },
    //确定添加选中的商品
    choiceGoodsFn() {
      let list = []
      console.log(this.tags, '-------------1')
      this.tags.forEach(res => {
        console.log(res.cate_name, '---------------')
        let index = null
        this.formValidate.sku_list.some((v, i) => {
          console.log(v)
          if (res.recovery_attr_id == v.recovery_attr_id) {
            index = i
            return true
          }
        })
        if (index != null) {
          this.formValidate.sku_list.map((res, i) => {
            if (i == index) {
              res.num++
            }
          })
        } else {
          list.push({
            cate_name: res.cate_name,
            sku: res.sku,
            recovery_attr_id: res.recovery_attr_id,
            image: [],
            remark: '',
            is_abnormal: 0,
            is_fail: 0,
            fail_num: 0,
            num: 1,
            recovery_category_id: res.old_recovery_category_id,
            abnormal_num: '', //异常数量
            is_Show: false,
            batch_list: [],
          })

        }
      })
      this.formValidate.sku_list = this.formValidate.sku_list.concat(list)
      this.visibleAddGood = false
      this.tags = []
      this.$refs.elTree.setCheckedKeys([])
      console.log(this.tags, '==============')
      this.closeDialogFn()
    },
    filterNodeFn(value, data) {//过滤节点
      if (!value) return true;
      return data.cate_name.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked) {//选择节点事件
        console.log(data,'---------------====')
      if (data.level == 3) {

        // 该节点未选中的时候
        let index = 'index'
        this.tags.some((v, i) => {
          if (data.recovery_attr_id == v.recovery_attr_id) {
            index = i
            return true
          }
        })
        let obj = {
          cate_name: data.categoryNameData.cate_name,
          sku: data.sku,
          recovery_attr_id: data.recovery_attr_id,
          old_recovery_category_id: data.old_recovery_category_id,
        }
        if (index != 'index') {
          if (checked == false) {
            this.$nextTick(() => {
              this.tags.splice(index, 1)

              // if (this.tags.length == 0) {
              //   this.tags = []
              // }
            })
          } else {
            this.tags.push(obj)
          }
        } else {
          this.tags.push(obj)
        }

      }

    },
    async getwaterCofFn() {//获取水印配置
      let {data} = await stockGetTempKeysApi()
      this.waterCof = data
    },
    httpRequest(files){
      let that = this
      let key = 'media/' + getNowDateFn().split('_')[0] + '/' + new Date().getTime() + 'zhemmei.mp4'
      let config = this.waterCof
      this.$nextTick(async () => {
        //上传视频
        this.uploadLoading = true
        const formData = new FormData();
        const file = new File([files.file], 'a.webm', {type: 'video/mp4'});
        let cos = new Cos({
          SecretId: 'AKIDpeNr581mQ4YoEWgfR3b8mR6au41jBPbe', // 临时密钥的 tmpSecretId
          SecretKey: 'z62kT7bwH7rQlphQvGZkrmXHo8HMNQOM', // 临时密钥的 tmpSecretKey
          //XCosSecurityToken: config.credentials.sessionToken, // 临时密钥的 sessionToken
          //ExpiredTime: config.expiredTime // 临时密钥失效时间戳，是申请临时密钥时，时间戳加 durationSeconds
        })
        cos.sliceUploadFile({
          Bucket: config.bucket, /* 必须 */
          Region: config.region, /* 必须 */
          Key: key, /* 必须 */
          Body: file, // 上传文件对象
          onProgress: function (progressData) {
            //uploading(progressData)
          }
        }, function (err, data) {
          console.log(config.cdn+data)
          that.formValidate.express_video.push(config.cdn+data.Key)
          that.$forceUpdate()
          if (err) {
            that.$message.error(err)
            return
          }
        })
      })
    },
    videoChange(file){
     this.file = file
    },
    closeDialogFn() {//关闭dialog弹框
      this.$nextTick(() => {
        this.$refs.elTree.setCheckedKeys([]);
        this.tags = []
      });
    },
    getGoodsFn() {//获取商品分类
      recoveryCategorySkuListApi().then((res) => {
        let tree = res.data.map((res => {
          res.disabled = true
          res.children.map((res2) => {
            res2.disabled = true
            res2.children.map((res3 => {
              res3.disabled = true
              res3.children.map((res4 => {
                res4.old_recovery_category_id = res4.recovery_category_id
                res4.recovery_category_id = res4.recovery_attr_id
              }))
            }))
          })
          return res
        }))
        this.treeData = tree
      })
    },
    addGoodFn() {//显示添加商品弹框
      this.visibleAddGood = true
    },
    batchFn(e, index, indexk) {//修改批号
      if (e <= 0) {
        this.$nextTick(() => {
          this.formValidate.sku_list[index].batch_list.splice(indexk, 1)
        })
      }
    },
    addBatchFn(item, index) {//添加批号
      this.formValidate.sku_list[index].batch_list.push({batch_number: '', batch_num: 1})
    },
    addSkuConfirmFn() {
      console.log(this.addSkuIndex)
      this.addSkuData = this.addSkuList[this.addSkuIndex]
      this.addSkuShow = false
      this.addSkuFn()
    },
    // 添加入库
    addPutInFn(item,item1){
      console.log(item1)
      let index = null
      /**
       * 判断添加的商品入库信息是有有该商品，没有直接添加，有则添加数量
       * */
      if
      (
        this.formValidate.sku_list.some((v,i)=>{
          console.log(v.recovery_attr_id , item.recovery_attr_id)
          if(v.recovery_attr_id == item.recovery_attr_id){
            index = i
            return true
          }}
        )
      )
      {
        this.formValidate.sku_list[index].num++
      }
      else
      {
        this.formValidate.sku_list.push({
          cate_name:item1.cate_name,
          sku: item.sku,
          recovery_attr_id: item.recovery_attr_id,
          image: [],
          remark: '',
          is_abnormal: 0,
          num: 1,
          recovery_category_id: item1.recovery_category_id,
          abnormal_num: '', //异常数量
          is_Show: false,
          batch_list: [],
        })
      }

    },
    getSkuFn() {//根据69码获取商品sku
      this.fullscreenLoading = true
      let list = []
      recoverySearchSkuBy69NumApi({warehousCode: this.warehousCode}).then((res) => {
        this.fullscreenLoading = false
        this.warehousCode = ''
        if (res.data.detail.length) {
          //判断是否已有数据
          // if (this.formValidate.sku_list.length) {
          //
          //   console.log(this.addSkuList)
          // } else {
          //   list = [{
          //     sku: res.data.detail.sku,
          //     recovery_attr_id: res.data.detail.recovery_attr_id,
          //     image: [],
          //     remark: '',
          //     is_abnormal: 0,
          //     num: 1,
          //     recovery_category_id: res.data.detail.recovery_category_id,
          //     abnormal_num: '', //异常数量
          //     is_Show: false,
          //     batch_list: [],
          //   }]
          //   this.formValidate.sku_list = this.formValidate.sku_list.concat(list)
          // }
          if (res.data.detail.length == 1) {
            this.addSkuData = res.data.detail[0]
            this.addSkuFn()
            return
          }
          this.addSkuShow = true
          this.addSkuList = res.data.detail

        } else {
          this.fullscreenLoading = false
          this.$message({
            message: '没有搜索到商品,请自行添加',
            type: 'error',
            duration: 3000,
            showClose: true,
            offset: 300
          })
        }


      }).catch((res) => {
        this.fullscreenLoading = false
        this.$message.error(res.message)
      })
    },
    addSkuFn() {
      let res = this.addSkuData
      let index = null
      let list = null
      console.log(this.formValidate.sku_list)
      this.formValidate.sku_list.some((v, i) => {
        if (res.recovery_attr_id == v.recovery_attr_id) {
          index = i
          return true
        }
      })
      if (index != null) {
        this.formValidate.sku_list.map((res, i) => {
          if (i == index) {
            res.num++
          }
        })
      } else {
        list = [{
          sku: res.sku,
          recovery_attr_id: res.recovery_attr_id,
          image: [],
          remark: '',
          is_abnormal: 0,
          is_fail: 0,
          fail_num: 0,
          num: 1,
          recovery_category_id: res.recovery_category_id,
          abnormal_num: '', //异常数量
          is_Show: false,
          batch_list: [],
        }]
        this.formValidate.sku_list = this.formValidate.sku_list.concat(list)
      }

    },
    getSkuBy69Fn(e) {//扫码识别69码
      if (e.trim()) {
        if (this.isSearchExp) clearTimeout(this.isSearchExp)
        this.isSearchExp = setTimeout(() => {
          this.warehousCode = this.warehousCode.trim()
          this.getSkuFn()
          this.$nextTick(() => {
            let div = document.getElementById('data-list-content')
            div.scrollTop = div.clientHeight
          })
        }, 1000)


      }
    },
    getOrderDetailsFn() {//搜索订单详情
      let that = this
      this.fullscreenLoading = true
      recoveryOrderDetailByExpNumApi({express_num: this.formValidate.express_num.trim()}).then((res) => {
        this.fullscreenLoading = false
        if (res.data.detail) {
          let list = []
          this.orderInfo = res.data.detail
          res.data.detail.express_list.some((v, i) => {
            if (that.formValidate.express_num.toLowerCase() == v.express_num.toLowerCase()) {
              if (!v.express_status || typeof v.express_status == 'undefined') {

                that.formValidate.express_video = v.express_video?v.express_video:[]
                that.formValidate.image = []
                that.formValidate.express_remark = v.express_remark?v.express_remark:"" // 入库备注
              } else {
                if (that.formValidate.express_num.toLowerCase() == v.express_num.toLowerCase()) {
                  that.formValidate.express_video = v.express_video?v.express_video:[]
                  that.formValidate.image = v.express_image
                  that.formValidate.express_remark = v.express_remark // 入库备注
                }

                v.product_list.map((item, index) => {
                  item.sku_list.map((item2, index2) => {
                    if (item2.batch_list) {
                      if (!item2.batch_list.length) {
                        item2.batch_list = []
                      }
                    } else {
                      item2.batch_list = []
                    }
                    item2.recovery_category_id = item.recovery_category_id
                    list.push(item2)
                  })

                })
              }
              this.formValidate.sku_list = list
              return true
            }
          })

          this.formValidate.express_list = res.data.detail.express_list
        } else {
          // this.$message({
          //   message: '没有搜索到订单信息',
          //   type: 'error',
          //   duration: 3000,
          //   showClose: true,
          //   offset: 300
          // })
          this.VisibleShow = true
          // this.formValidate.express_num=''
          // this.orderInfo = {category_id: null}
          // this.is_search = false
          return
        }
        this.$nextTick(() => {
          this.$refs.warehousCode.focus()
        })
      }).catch(res => {
        this.fullscreenLoading = false
        this.$message.error(res.message)
      })
      this.is_search = true
    },
    getOrderByExpFn(e) {//扫码枪识别快递
      if (e) {
        if (this.isSearchExp) clearTimeout(this.isSearchExp)
        this.isSearchExp = setTimeout(() => {
          // this.formValidate.express_num=this.formValidate.express_num.trim()
          this.formValidate.express_num = (this.formValidate.express_num.trim()).toUpperCase()
          if (!this.formValidate.express_num.trim()) return
          this.getOrderDetailsFn()
        }, 1000)
      }
    },
    // 成功上传视频
    handleAvatarSuccess(e){
        console.log(e)
    },
    // 提交
    handleSubmit() {
      if (!this.formValidate.express_num) {
        this.$message({
          message: '没有录入订单号',
          type: 'error',
          duration: 3000,
          showClose: true,
          offset: 300
        })
        return
      }
      if (this.$refs.batchNum) {
        if (this.$refs.batchNum.some((res) => {
          if (!res.value.trim()) {
            res.focus()
            return true
          }
        })) {
          this.$message({
            message: '请检查批号录入情况',
            type: 'error',
            duration: 3000,
            showClose: true,
            offset: 300
          })
          return
        }
      }
      this.formValidate.sku_list.map((v,i)=>{
        if(v.remarkSelect != '其他'){
          v.remark = v.remarkSelect?v.remarkSelect:''
        }else{
          v.remark = v.remark?v.remark:''
        }
      })
      if (this.formValidate.sku_list.some((v, i) => {
        return v.is_fail && !v.fail_num
      })) {
        this.$message({
          message: '请检查假货录入情况',
          type: 'error',
          duration: 3000,
          showClose: true,
          offset: 300
        })
        return
      }
      console.log(this.orderInfo.category_id)
      if(this.orderInfo.category_id){
        let orderNum = 0
        let puintNum = 0
        this.orderInfo.product_list.map((item,index)=>{
          item.sku_list.map((v,i)=>{
            orderNum += v.num
          })
        })
        this.formValidate.sku_list.map((v,i)=>{
          puintNum += v.num
        })
        if(puintNum != orderNum){
          this.$alert('报单商品数量与入库商品数量不一致，请确认是否核实无误', {
            confirmButtonText: '确认无误',
            cancelButtonText:'前去核实',
            showCancelButton:true,
            callback: action => {
              if(action =='confirm'){
                this.postOrderFn()
              }
            }
          });
        }else{
          this.postOrderFn()
        }
      }else{
        this.postOrderFn()
      }


    },
    postOrderFn(){
      let params = {
        express_num: this.formValidate.express_num.trim(),
        express_image: this.formValidate.image,
        sku_list: this.formValidate.sku_list,
        express_video: this.formValidate.express_video,
        express_remark: this.formValidate.express_remark
      }
      // 判断是否搜索出物流
      if (this.orderInfo.recovery_order_id) {
        for (let i = 0; i < this.orderInfo.express_list.length; i++) {
          if (this.orderInfo.express_list[i].express_num.toLowerCase() == this.formValidate.express_num.toLowerCase()) {
            params.express_num = this.orderInfo.express_list[i].express_num
          }
        }
      } else {
        params.express_num = this.formValidate.express_num
      }
      orderWarehousApi(params).then((res) => {
        this.$message.success(res.message)
        this.formValidate = {
          logistics_num: '',
          image: [],
          express_remark: '',
          is_abnormal: 0,
          express_video: [],
          sku_list: [],
        }
        this.$forceUpdate()
        this.orderInfo = {category_id: null}
        this.is_search = false
        this.$nextTick(() => {
          this.$refs.expNum.focus()
        })
      }).catch((res) => {
        this.$message.error(res.message)
      })
    }
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-upload--picture-card {
  display: none;
}

::v-deep .el-upload-list__item {
  transition: none !important;
}

.label_tip {
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}

.selWidth {
  width: 100%;
}

.selWidthd {
  width: 300px;
}

.dialog-scustom, .addDia {
  min-width: 400px;
  height: 900px;

  .el-dialog {
    width: 400px;
  }

  h3 {
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}

.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

/deep/ .el-radio {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: row-reverse;
}

.agreement {
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0, 0, 0, .2);
  padding: 26px;
  border-radius: 15px;

  .content {
    height: 600px;
    overflow-y: scroll;

    /deep/ p {
      font-size: 13px;
      line-height: 22px;
    }
  }

  /deep/ img {
    max-width: 100%;
  }

  p {
    text-align: justify;
  }
}

/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track {
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}

.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}

.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}

.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}

.uploadVideo {
  margin-left: 10px;
}

.perW50 {
  width: 50%;
}

.submission {
  margin-left: 10px;
}

.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}

.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

</style>
